/* Native Shopify discount owns all cart/checkout prices. No client-side price mutation. */
(() => {
  if (customElements.get('sillage-bundle')) return;
  let serial = 0;
  class SillageBundle extends HTMLElement {
    connectedCallback() {
      if (this.initialized) { this.native?.forEach(el => el.classList.add('s30-native-hidden')); return; }
      try { this.catalog = JSON.parse(this.querySelector('[data-catalog]').textContent); }
      catch { return; }
      this.current = this.catalog.find(v => String(v.id) === this.dataset.current);
      if (!this.current || !this.catalog.length) return;
      this.count = Number(this.dataset.count) || 3;
      this.unit = Number(this.dataset.unit) || 1299;
      this.total = Number(this.dataset.total) || 2999;
      if (![2,3].includes(this.count) || this.current.price !== this.unit || this.total >= this.unit*this.count) return;
      const defaults = {title:'Composez votre lot',single:'1 parfum',lot:'[nombre] parfums au choix',badge:'Offre découverte',saving:'Économisez',add:'Ajouter au panier',select:'Choisir un parfum'};
      try { this.labels = {...defaults,...JSON.parse(this.querySelector('[data-labels]')?.textContent || '{}')}; } catch { this.labels = defaults; }
      this.money = value => new Intl.NumberFormat('fr-FR',{style:'currency',currency:'EUR'}).format(value/100);
      const esc = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      this.initialized = true;
      this.root = this.dataset.root || '/';
      if (!this.root.endsWith('/')) this.root += '/';
      this.uid = `s30-${++serial}`;
      this.ui = this.querySelector('[data-bundle-ui]');
      this.ui.innerHTML = `<fieldset><legend>${esc(this.labels.title)}</legend>
        <label class="s30-choice"><input type="radio" name="${this.uid}" value="single" checked><span class="s30-label">${esc(this.labels.single)}</span><span class="s30-prices">${this.money(this.unit)}</span></label>
        <label class="s30-choice s30-featured"><span class="s30-best">${esc(this.labels.badge)}</span><input type="radio" name="${this.uid}" value="triple"><span class="s30-label">${esc(this.labels.lot.replace('[nombre]',this.count))}<span class="s30-subtitle s30-saving-line">${esc(this.labels.saving)} ${this.money(this.unit*this.count-this.total)}</span></span><span class="s30-prices">${this.money(this.total)}<del>${this.money(this.unit*this.count)}</del></span></label></fieldset>
        <div class="s30-picks" hidden><div data-rows></div></div>
        <button type="button" data-add></button>
        <p class="s30-status" role="status" aria-live="polite" hidden></p>`;
      const rows = this.ui.querySelector('[data-rows]');
      for (let i = 0; i < this.count; i++) {
        const row = document.createElement('div'); row.className = 's30-row';
        const image = document.createElement('img'); image.className = 's30-image'; image.alt = ''; image.hidden = true;
        const field = document.createElement('div'); field.className = 's30-field';
        const label = document.createElement('label'); label.htmlFor = `${this.uid}-${i}`; label.textContent = `Parfum ${i + 1}`;
        const select = document.createElement('select'); select.id = label.htmlFor;
        select.add(new Option(this.labels.select, ''));
        for (const v of this.catalog) {
          const title = v.title + (v.variantTitle !== 'Default Title' ? ` — ${v.variantTitle}` : '');
          const option = new Option(title + (!v.available ? ' — Épuisé' : ''), String(v.id));
          option.disabled = !v.available; select.add(option);
        }
        if (i === 0 && this.current.available) select.value = String(this.current.id);
        field.append(label, select); row.append(image, field); rows.append(row);
      }
      this.selects = [...this.ui.querySelectorAll('select')];
      this.button = this.ui.querySelector('[data-add]');
      this.status = this.ui.querySelector('.s30-status');
      this.ui.addEventListener('change', () => { this.status.hidden = true; this.refresh(); });
      this.button.addEventListener('click', () => this.add());
      this.ui.hidden = false;
      this.native = [...(this.closest('.product-details')?.querySelectorAll('.buy-buttons-block') || [])];
      this.native.forEach(el => el.classList.add('s30-native-hidden'));
      this.refresh();
    }
    disconnectedCallback() { this.native?.forEach(el => el.classList.remove('s30-native-hidden')); }
    selection() {
      const mode = this.ui.querySelector('input:checked').value;
      return mode === 'single' ? [this.current] : this.selects.map(s => this.catalog.find(v => String(v.id) === s.value));
    }
    refresh() {
      const triple = this.ui.querySelector('input:checked').value === 'triple';
      this.ui.querySelector('.s30-picks').hidden = !triple;
      this.selects.forEach(s => {
        const v = this.catalog.find(v => String(v.id) === s.value);
        const img = s.closest('.s30-row').querySelector('img');
        img.hidden = !v?.image; if (v?.image) img.src = v.image;
      });
      const selected = this.selection();
      const counts = new Map();
      selected.filter(Boolean).forEach(v => counts.set(v.id, (counts.get(v.id) || 0) + 1));
      const insufficient = selected.some(v => v && v.stock !== null && counts.get(v.id) > v.stock);
      this.button.disabled = selected.some(v => !v || !v.available) || insufficient;
      this.button.textContent = insufficient ? 'Quantité indisponible' : this.current.available || triple ? `${this.labels.add} · ${this.money(triple ? this.total : this.unit)}` : 'Épuisé';
    }
    async add() {
      if (this.busy || this.button.disabled) return;
      const selected = this.selection();
      if (selected.some(v => !v)) return;
      this.busy = true; this.button.disabled = true; this.status.hidden = true;
      this.button.textContent = 'Vérification du stock…';
      this.ui.querySelectorAll('input,select').forEach(el => el.disabled = true);
      let submitted = false;
      try {
        const quantities = new Map(); selected.forEach(v => quantities.set(v.id, (quantities.get(v.id) || 0) + 1));
        const json = async url => { const r = await fetch(url, {cache:'no-store'}); if (!r.ok) throw Error('Vérification impossible. Réessayez dans un instant.'); return r.json(); };
        const handles = [...new Set(selected.map(v => v.handle))];
        const [cart, ...products] = await Promise.all([json(this.root + 'cart.js'), ...handles.map(h => json(this.root + 'products/' + encodeURIComponent(h) + '.js'))]);
        for (const [id, quantity] of quantities) {
          const live = products.flatMap(p => p.variants).find(v => String(v.id) === String(id));
          const initial = selected.find(v => v.id === id);
          const inCart = cart.items.filter(v => String(v.variant_id) === String(id)).reduce((s,v) => s + v.quantity, 0);
          if (!live?.available) throw Error(`${initial.title} n’est plus disponible. Choisissez un autre parfum.`);
          if (live.price !== this.unit) throw Error('Le prix a changé. Rechargez la page avant de continuer.');
          if (initial.stock !== null && quantity + inCart > initial.stock) throw Error(`Stock insuffisant pour ${initial.title}, en tenant compte de votre panier.`);
        }
        this.button.textContent = 'Ajout au panier…';
        submitted = true;
        const response = await fetch(this.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[...quantities].map(([id,quantity]) => ({id,quantity}))})});
        const data = await response.json();
        if (!response.ok || data.status) throw Error(data.description || 'Impossible d’ajouter tous les parfums.');
        window.location.assign(this.root + 'cart');
      } catch (error) {
        this.status.textContent = error.message || 'Une erreur est survenue.';
        if (submitted) {
          this.status.append(document.createTextNode(' Vérifiez le panier avant de réessayer : '));
          const link = document.createElement('a'); link.href = this.root + 'cart'; link.textContent = 'Voir mon panier'; this.status.append(link);
        }
        this.status.hidden = false;
      } finally {
        this.busy = false;
        this.ui.querySelectorAll('input,select').forEach(el => el.disabled = false);
        this.refresh();
      }
    }
  }
  customElements.define('sillage-bundle', SillageBundle);
})();
